import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  /*   private messageService = inject(MessageService); */
  constructor(private messageService: MessageService) {}

  public showSuccess(message: string): void {
    this.messageService.add({ severity: 'success', summary: 'Erfolg', detail: message });
  }

  public showError(message: string): void {
    this.messageService.add({ severity: 'error', summary: 'Fehler', detail: message });
  }

  public showInfo(message: string): void {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
  }

  public showWarning(message: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Warnung', detail: message });
  }
}
